import Skeleton from 'react-loading-skeleton'
import 'swiper/css/pagination'
import 'swiper/css'

const SkeletonElement = ({ isDesktop = false }) => {
  return (
    <div className='mag__element'>
      {isDesktop && <Skeleton
        containerClassName='skeleton__img'
        height='200px'
      />}
      <div className='element__group group'>
        <Skeleton
          containerClassName='skeleton__title'
          count={2}
        />
      </div>
      <Skeleton className='skeleton__icons' count={isDesktop ? 1 : 2} />
      <Skeleton className='skeleton__icons' height='5em' />

      <div className='element__buttons group'>
        <Skeleton containerClassName='skeleton__button' height='2.5em' />
        {!isDesktop && <Skeleton className='skeleton__detail' height='2.5em' />}
      </div>
    </div>
  )
}

export default SkeletonElement